var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hiv-quiz',{attrs:{"question":"You can’t get HIV from a guy who usually just has sex with women.","answer":false}})}
var staticRenderFns = []

export { render, staticRenderFns }